import {
  AfterViewInit,
  Component,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild,
  ViewContainerRef,
  ViewEncapsulation,
} from '@angular/core';

// services
import { GlobalService } from '../../../core/services/global.service';
import { environment } from '../../../../environments/environment';
import { CommonModule } from '@angular/common';
import { SocialIconsComponent } from '../social-icons/social-icons.component';
import { SafeHtmlPipe } from '../../pipes/safe-html.pipe';
import { IconsModule } from '../../modules/icons/icons.module';
import { LazyImgDirective } from '../../directive/lazy-img.directive';
import { CDNImgDirective } from '../../directive/cdn-img.directive';
import { AnalyticsService } from '../../services/analytics.service';
import { LogoTnComponent } from './components/logo-tn/logo-tn.component';
import { RegisterComponentsService } from 'src/app/editor/services/register-components.service';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { WebsiteService } from '../../services/website.service';
import { NewsletterComponent } from './components/newsletter/newsletter.component';
import { SocialMediaComponent } from './components/social-media/social-media.component';
import { ContactComponent } from './components/contact/contact.component';
import { MethodShipmentComponent } from './components/method-shipment/method-shipment.component';
import { MethodPaymentComponent } from './components/method-payment/method-payment.component';
import { MenuMainComponent } from './components/menu-main/menu-main.component';
import { environment as env } from 'src/environments/environment';

const template_url =
  env.template_id === 47
    ? './templates/footer.47.component.html'
    : './footer.component.html';



@Component({
  selector: 'app-footer',
  templateUrl: template_url,
  styleUrls: [
    `./footer.component.scss`,
    `./styles/footer.${env.template_id}.component.scss`,
  ],
  standalone: true,
  imports: [
    CommonModule,
    SocialIconsComponent,
    SafeHtmlPipe,
    IconsModule,
    LazyImgDirective,
    CDNImgDirective,
    LogoTnComponent,
    NewsletterComponent,
    SocialMediaComponent,
    ContactComponent,
    MethodShipmentComponent,
    MethodPaymentComponent,
    MenuMainComponent,
  ],
})
export class FooterComponent implements OnInit, AfterViewInit, OnChanges {
  menu = [];
  categories: any = [];
  env = environment;
  currentYear: number = new Date().getFullYear();

  methodPayments = [];
  methodShipments = [];

  @ViewChild('ViewContainer', { read: ViewContainerRef })
  viewContainer: ViewContainerRef;

  constructor(
    public globalService: GlobalService,
    private _analyticsService: AnalyticsService,
    private registerComponentsService: RegisterComponentsService
  ) {}

  ngOnInit() {
    //console.log(this.globalService.footer);
  }

  ngOnChanges(changes: SimpleChanges): void {
     console.log(this.globalService.footer);
  }

  ngAfterViewInit(): void {
    this.registerComponentsService.setViewContainerRef({
      idSection: null,
      typeSection: 'footer',
      viewRef: this.viewContainer,
    });
  }
}
